import React, { ReactNode, useState, useEffect } from "react";
import CountryCode from "models/CountryCode";
import PlatformSelect from "./PlatformSelect";
import StoreSelect from "./StoreSelect";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
    IEditionPurchaseLinkConfig,
    IPlatformPurchaseLinkConfig,
    IStorePurchaseLinkConfig,
} from "models/IAppConfig";
import BackArrowIcon from "assets/svgs/icons/BackArrowIcon";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            "&:hover": {
                textDecoration: "underline",
            },
        },
    })
);

interface IUsePlatformLinksConfigResponse {
    platformLinks: ReactNode;
    storeLinks: ReactNode;
    backButton: ReactNode;
}

interface IProps {
    selectedCountry: CountryCode;
    editionPurchaseLinkConfig?: IEditionPurchaseLinkConfig;
    currentSelectedPlatform?: IPlatformPurchaseLinkConfig;
    onPlatformSelect: (platform: IPlatformPurchaseLinkConfig) => void;
    onBack: () => void;
}

export default function usePlatformSelectionLinks(props: IProps): IUsePlatformLinksConfigResponse {
    const classes = useStyles();
    const {
        selectedCountry,
        editionPurchaseLinkConfig = {},
        currentSelectedPlatform,
        onPlatformSelect,
        onBack,
    } = props;

    const purchaseLinkConfig = editionPurchaseLinkConfig[selectedCountry];
    const [currentlySelectedStore, setCurrentlySelectedStore] = useState<
        IStorePurchaseLinkConfig | undefined
    >(undefined);

    useEffect(() => {
        setCurrentlySelectedStore(undefined);
    }, [selectedCountry]);

    if (typeof purchaseLinkConfig === "undefined") {
        console.log(`purchaseLinkConfig for ${selectedCountry} is undefined`);
        return {
            platformLinks: null,
            storeLinks: null,
            backButton: null,
        };
    }

    const backButtonOnClick =
        typeof currentlySelectedStore === "undefined"
            ? onBack
            : () => setCurrentlySelectedStore(undefined);

    return {
        platformLinks: (
            <PlatformSelect
                purchaseLinkConfig={purchaseLinkConfig}
                onPlatformSelect={onPlatformSelect}
            />
        ),
        storeLinks:
            typeof currentSelectedPlatform?.storeLinks === "undefined" ? null : (
                <StoreSelect
                    stores={currentSelectedPlatform.storeLinks}
                    platformCode={currentSelectedPlatform.platformCode}
                    currentlySelectedStore={currentlySelectedStore}
                    onSubscriptionStoreTabClick={(store) => setCurrentlySelectedStore(store)}
                />
            ),
        backButton:
            typeof currentSelectedPlatform === "undefined" ? null : (
                <div style={{ display: "flex" }}>
                    <div className={classes.backButton} onClick={backButtonOnClick}>
                        <div
                            style={{
                                width: 20,
                                display: "flex",
                                alignItems: "center",
                                marginRight: 5,
                            }}
                        >
                            <BackArrowIcon style={{ flex: 1 }} />
                        </div>
                        <Typography variant="h6">Back</Typography>
                    </div>
                </div>
            ),
    };
}
